import { render, staticRenderFns } from "./VideoBooking.vue?vue&type=template&id=4463f8a2"
import script from "./VideoBooking.vue?vue&type=script&lang=js"
export * from "./VideoBooking.vue?vue&type=script&lang=js"
import style0 from "./VideoBooking.vue?vue&type=style&index=0&id=4463f8a2&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports